import { render, staticRenderFns } from "./selectphonenum.vue?vue&type=template&id=133547aa&scoped=true"
import script from "./selectphonenum.vue?vue&type=script&lang=js"
export * from "./selectphonenum.vue?vue&type=script&lang=js"
import style0 from "./selectphonenum.vue?vue&type=style&index=0&id=133547aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133547aa",
  null
  
)

export default component.exports